import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components/macro';

interface AutoHidingPanelProps {
  children: any;
  isFullScreen?: boolean;
}

const Wrapper = styled.div<any>`
  position: relative;
  transition: bottom .5s ease-in-out;
  bottom: 0;

  ${props => props.isFullScreen && `
  margin-top: -80px;  
`}

  ${props => props.isHidden && `
  bottom: -160px;
`}
`;

const HIDING_TIMEOUT_MS = 3000;

let timeout;
const AutoHidingPanel = ({
  children,
  isFullScreen,
}:AutoHidingPanelProps) => {
  const [hidden, setHidden] = useState(false);

  const resetTimeout = useCallback(() => {
    clearTimeout(timeout);
    setHidden(false);

    if (isFullScreen) {
      timeout = setTimeout(() => {
        setHidden(true);
      }, HIDING_TIMEOUT_MS);
    }
  }, [isFullScreen]);

  useEffect(() => {
    resetTimeout();
    window.addEventListener('mousemove', resetTimeout);

    return () => {
      window.removeEventListener('mousemove', resetTimeout);
    }
  }, [isFullScreen, resetTimeout]);

  return (
    <Wrapper isFullScreen={isFullScreen} isHidden={isFullScreen && hidden}>
      { children }
    </Wrapper>
  );
}

export default AutoHidingPanel;
